module.exports = "./img/a5269ed13e1603d22e77b6772f8866a5.jpg";